export function downloadBlob(blob: Blob, filename) {
    const link = document.createElement('a');
    // HOT-2481 - enable downloads in Edge and IE
    const blobUrl = window.URL.createObjectURL(blob);
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
    }, 0);
}
